import React, { useState } from 'react';
import { ClickAwayListener, Paper } from '@material-ui/core';
import { CapitalPopper } from 'react-components/capital/CapitalPopper';
import { _T } from '../../../include/appI18n';
import { appUrl } from '../../../include/utils';
/** Anchored details must not remove the page scrollbar when opened. */
export function CapitalCartPricePopover({ anchorEl, onClose, children }) {
    const [arrow, setArrow] = useState(null);
    return React.createElement(CapitalPopper, { open: !!anchorEl, anchorEl: anchorEl, onClose: onClose, closeOnScroll: true, width: 397, placement: "top", className: "capital-cart-price-surface", modifiers: { arrow: { enabled: true, element: arrow } } },
        React.createElement(ClickAwayListener, { onClickAway: event => { if (!(anchorEl === null || anchorEl === void 0 ? void 0 : anchorEl.contains(event.target)))
                onClose(); } },
            React.createElement("div", { className: "capital-cart-price-wrap" },
                React.createElement(Paper, { role: "dialog", "aria-label": _T.BOOKING_DETAILED_PRICE, tabIndex: -1, className: "capital-cart-price-popover detailed-price" },
                    React.createElement("h3", null,
                        React.createElement("img", { src: appUrl('/Content/capital/assets/cart-info.svg'), alt: "" }),
                        _T.BOOKING_DETAILED_PRICE),
                    children),
                React.createElement("span", { ref: setArrow, className: "capital-cart-price-arrow", "aria-hidden": "true" },
                    React.createElement("img", { src: appUrl('/Content/capital/assets/cart-popover-arrow.svg'), alt: "" })))));
}
